<template>
  <v-container>
    <rest-resource-table
      label="Options"
      resource-name="options"
      resource-id-name="id"
      allow-new
      allow-delete
      edit-permission="editOptions"
    >
      <template v-slot:form="{ item }">
        <div>
          <v-text-field
            label="Name"
            v-model="item.name"
            :readonly="!!item.id"
          ></v-text-field>
          <v-text-field
            label="Value"
            :value="JSON.stringify(item.value)"
            @input="item.value = setValue($event, item, item.id)"
            :error-messages="errors[item.id] || ''"
            hide-details="auto"
          ></v-text-field>
        </div>
      </template>
    </rest-resource-table>
  </v-container>
</template>

<script>
import restResourceTable from "@/components/lib/RestResourceTable.vue";
export default {
  name: "adminOptions",
  components: {
    restResourceTable
  },
  data() {
    return { errors: {} };
  },
  methods: {
    setValue(ev, obj, id) {
      console.log(ev, obj, id);
      let value = ev;
      try {
        value = JSON.parse(ev);
        this.errors[id] = "";
      } catch (e) {
        value = obj.value;
        this.$set(this.errors, id, e.message);
        console.error(e);
      }
      return value;
    }
  }
};
</script>
